import { FEEDBACK_URL, noop } from '@aloft/toolkit-shared';
import { Block, Button, Link as SUILink } from '@aloft/toolkit-sui';

import { ErrorPageLayout } from '../layout/ErrorPageLayout.tsx';

// NOTE: this cannot be called outside of an SUI provider
export const ToolkitGenericFallback = () => (
  <ErrorPageLayout
    title="We're sorry, something went wrong on our end."
    body={
      <>
        Refresh the page or&nbsp;
        <SUILink isExternal href={FEEDBACK_URL}>
          Contact Us.
        </SUILink>
        <Block marginTop={4}>
          {/* TODO: SUI Button variant that renders Button styles as Link */}
          <a href="/" style={{ textDecoration: 'none' }}>
            <Button text="Back to My Orders" variant="primary" onClick={noop} size="md" />
          </a>
        </Block>
      </>
    }
  />
);
